import React, { useState } from 'react';
import Modal from '../../Modal';
import keyType from '../Pix/PixKeyConfig';

const PixKeyForm = ({
    pixKey,
    amount,
    description,
    beneficiaryName,
    beneficiaryCity,
    handlePixKeyChange,
    handleAmountChange,
    handleDescriptionChange,
    handleBeneficiaryNameChange,
    handleBeneficiaryCityChange,
    handlePixTypeChange,
    onAllowUserToEnterAmountChange // Certifique-se de que esta função não está em conflito
}) => {
    const [allowUserToEnterAmount, setAllowUserToEnterAmount] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPixType, setSelectedPixType] = useState('Telefone');

    const handleAllowUserToEnterAmountToggle = () => {
        setAllowUserToEnterAmount(!allowUserToEnterAmount);
        setIsModalOpen(true);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const onPixTypeChange = (e) => {
        setSelectedPixType(e.target.value);
        handlePixTypeChange(e);
    };

    const pixKeyConfig = keyType[selectedPixType];

    return (
        <div>
            <div className="form-group">
                <label htmlFor="pixKey">Chave Pix</label>
                <div className="pix-key-container">
                    <select id="pixType" onChange={onPixTypeChange}>
                        <option value="Telefone">Telefone</option>
                        <option value="Email">Email</option>
                        <option value="CPF">CPF</option>
                        <option value="CNPJ">CNPJ</option>
                        <option value="Outro">Outro</option>
                    </select>
                    <input
                        type={pixKeyConfig.type}
                        id="pixKey"
                        value={pixKey}
                        placeholder={pixKeyConfig.placeholder}
                        aria-label={pixKeyConfig["aria-label"]}
                        inputMode={pixKeyConfig.inputmode}
                        onChange={handlePixKeyChange}
                    />
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="amount">Valor</label>
                <input
                    type="text"
                    id="amount"
                    value={amount}
                    placeholder="1.50"
                    onChange={handleAmountChange}
                />
            </div>
            <div className="form-group">
                <label htmlFor="beneficiaryName">Nome do Beneficiário</label>
                <input
                    type="text"
                    id="beneficiaryName"
                    value={beneficiaryName}
                    placeholder="Nome do Beneficiário"
                    onChange={handleBeneficiaryNameChange}
                />
            </div>
            <div className="form-group">
                <label htmlFor="beneficiaryCity">Cidade do Beneficiário</label>
                <input
                    type="text"
                    id="beneficiaryCity"
                    value={beneficiaryCity}
                    placeholder="Cidade do Beneficiário"
                    onChange={handleBeneficiaryCityChange}
                />
            </div>
            <div className="form-group">
                <label htmlFor="description">Descrição</label>
                <input
                    type="text"
                    id="description"
                    value={description}
                    placeholder="Ex.: Pagamento de Serviço"
                    onChange={handleDescriptionChange}
                />
            </div>
            <div className="form-group toggle-tracking-options" onClick={handleAllowUserToEnterAmountToggle}>
                <div className="toggle-switch">
                    <input
                        type="checkbox"
                        disabled
                    />
                    <label className="toggle-label">
                        <span className="toggle-button"></span>
                    </label>
                </div>
                <span>Possibilitar o usuário digitar o valor no momento do pix</span>
            </div>
            <Modal isOpen={isModalOpen} toggleModal={toggleModal} />
        </div>
    );
};

export default PixKeyForm;